module.exports = __webpack_public_path__ + "static/img/bg-01.95921ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fullwidth/bg-01.png
// module id = 4j9T
// module chunks = 1